function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCoinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 480 480",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -540.36)"
  }, /*#__PURE__*/React.createElement("g", {
    shapeRendering: "auto",
    imageRendering: "auto",
    colorRendering: "auto",
    colorInterpolation: "sRGB"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB61C"
    },
    d: "M240,540.36c-132.531,0-240,107.469-240,240s107.469,240,240,240s240-107.469,240-240 C480,647.829,372.531,540.36,240,540.36L240,540.36z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCD116"
    },
    d: "M240,543.36c130.909,0,237,106.091,237,237s-106.091,237-237,237S3,911.269,3,780.36 S109.091,543.36,240,543.36z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEBC1A"
    },
    d: "M268.209,578.152c-0.555,10.599-9.597,18.741-20.196,18.186 c-10.599-0.555-18.741-9.597-18.186-20.196l0,0c0.555-10.599,9.597-18.741,20.196-18.186l0,0 C260.621,558.511,268.763,567.553,268.209,578.152z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEBC1A"
    },
    d: "M246.932,984.579c-0.555,10.599-9.597,18.741-20.196,18.186c0,0,0,0,0,0 c-10.599-0.555-18.741-9.597-18.186-20.196l0,0c0.555-10.599,9.597-18.741,20.196-18.186c0,0,0,0,0,0 C239.345,964.938,247.487,973.98,246.932,984.579L246.932,984.579z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEBC1A"
    },
    d: "M442.099,796.995c-10.613,0.135-19.325-8.359-19.46-18.972l0,0 c-0.135-10.613,8.359-19.325,18.972-19.46l0,0c10.613-0.135,19.325,8.359,19.46,18.972l0,0 C461.205,788.147,452.711,796.86,442.099,796.995L442.099,796.995z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEBC1A"
    },
    d: "M35.148,802.159c-10.613,0.135-19.325-8.359-19.46-18.972l0,0 c-0.135-10.613,8.359-19.325,18.972-19.46s19.325,8.359,19.46,18.972c0,0,0,0,0,0C54.254,793.312,45.76,802.024,35.148,802.159 C35.148,802.159,35.148,802.159,35.148,802.159z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEBC1A"
    },
    d: "M425.402,862.827c-10.071-3.35-15.519-14.23-12.169-24.301l0,0 c3.35-10.071,14.23-15.519,24.301-12.169l0,0c10.071,3.35,15.519,14.23,12.169,24.301l0,0 C446.353,860.729,435.473,866.177,425.402,862.827L425.402,862.827z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEBC1A"
    },
    d: "M39.225,734.364c-10.071-3.35-15.519-14.23-12.169-24.301c3.35-10.071,14.23-15.519,24.301-12.169 c10.071,3.35,15.519,14.23,12.169,24.301C60.175,732.266,49.296,737.714,39.225,734.364z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEBC1A"
    },
    d: "M415.522,672.726c-8.225,6.708-20.33,5.478-27.038-2.747c-6.708-8.225-5.478-20.33,2.747-27.038 c8.225-6.708,20.33-5.478,27.038,2.747S423.747,666.018,415.522,672.726L415.522,672.726z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEBC1A"
    },
    d: "M88.57,917.781c-8.225,6.708-20.33,5.478-27.038-2.747s-5.478-20.33,2.747-27.038 c8.225-6.708,20.33-5.478,27.038,2.747S96.795,911.073,88.57,917.781z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEBC1A"
    },
    d: "M436.106,728.57c-9.969,3.643-21.003-1.486-24.646-11.454c-3.643-9.969,1.486-21.003,11.454-24.646 l0,0c9.969-3.643,21.003,1.486,24.646,11.454l0,0C451.203,713.893,446.075,724.927,436.106,728.57 C436.106,728.57,436.106,728.57,436.106,728.57z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEBC1A"
    },
    d: "M53.844,868.252c-9.969,3.643-21.003-1.486-24.646-11.454c-3.643-9.969,1.486-21.003,11.454-24.646 c0,0,0,0,0,0c9.969-3.643,21.003,1.486,24.646,11.454C68.941,853.575,63.812,864.609,53.844,868.252 C53.844,868.252,53.844,868.252,53.844,868.252z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEBC1A"
    },
    d: "M270.765,982.176c-2.659-10.275,3.514-20.76,13.789-23.42h0c10.275-2.659,20.76,3.514,23.42,13.789 c2.659,10.275-3.514,20.76-13.789,23.42C283.91,998.624,273.425,992.451,270.765,982.176L270.765,982.176z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEBC1A"
    },
    d: "M168.785,588.176c-2.659-10.275,3.514-20.76,13.789-23.42c0,0,0,0,0,0 c10.275-2.659,20.76,3.514,23.42,13.789s-3.514,20.76-13.789,23.42h0C181.93,604.625,171.445,598.451,168.785,588.176 L168.785,588.176z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEBC1A"
    },
    d: "M100.071,930.857c6.415-8.455,18.47-10.109,26.925-3.694h0c8.455,6.415,10.109,18.47,3.694,26.925 c-6.415,8.455-18.47,10.109-26.925,3.694c0,0,0,0,0,0C95.31,951.367,93.656,939.312,100.071,930.857z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEBC1A"
    },
    d: "M346.069,606.633c6.415-8.455,18.47-10.109,26.925-3.694c8.455,6.415,10.109,18.47,3.694,26.925 s-18.47,10.109-26.925,3.694c0,0,0,0,0,0C341.307,627.143,339.653,615.089,346.069,606.633L346.069,606.633z"
  })), /*#__PURE__*/React.createElement("g", {
    shapeRendering: "auto",
    imageRendering: "auto",
    colorRendering: "auto",
    colorInterpolation: "sRGB"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F39C12"
    },
    d: "M240,611.382c-93.321,0-168.98,75.658-168.98,168.979s75.66,168.98,168.98,168.98 s168.98-75.659,168.98-168.98S333.321,611.382,240,611.382z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB61C"
    },
    d: "M240,612.096c92.934,0,168.266,75.33,168.266,168.264S332.934,948.626,240,948.626 S71.736,873.294,71.736,780.36S147.066,612.096,240,612.096z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F39C12"
    },
    d: "M240,605.505c-96.537,0-174.857,78.318-174.857,174.855S143.464,955.217,240,955.217 c96.537,0,174.857-78.32,174.857-174.857S336.537,605.505,240,605.505z M240,611.219c93.449,0,169.143,75.692,169.143,169.141 S333.449,949.503,240,949.503c-93.448,0-169.143-75.694-169.143-169.143C70.858,686.911,146.552,611.219,240,611.219L240,611.219z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6A419"
    },
    d: "M226.577,677.438v29.497c-20.967,8.621-33.389,31.201-29.559,54.014 c4.042,24.073,25.359,41.912,49.6,40.927c6.008,0.75,11.033,5.391,12.207,12.382c1.353,8.057-3.347,15.326-10.351,17.313 c-7.004,1.987-14.053-1.496-16.871-9.062l-31.989,11.918c4.852,13.023,14.88,22.943,26.964,28.011v29.839h34.137v-28.806 c22.302-7.899,35.739-31.258,31.776-54.864c-4.041-24.07-25.353-41.906-49.589-40.927c-6.014-0.745-11.043-5.388-12.218-12.385 c-1.353-8.057,3.347-15.326,10.351-17.313c7.004-1.987,14.052,1.499,16.871,9.065l31.99-11.918 c-5.145-13.811-16.114-24.133-29.181-28.878v-28.814L226.577,677.438L226.577,677.438z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB61C"
    },
    d: "M220.844,671.96v0.98v28.906c-21.011,8.99-33.413,31.743-29.547,54.77 c4.122,24.55,25.864,42.75,50.607,41.744l-0.162-0.008c5.581,0.697,10.251,4.961,11.361,11.57 c1.275,7.596-3.14,14.362-9.65,16.209c-6.549,1.857-13.019-1.304-15.686-8.461l-0.342-0.92l-33.828,12.604l0.344,0.918 c4.867,13.064,14.85,23.042,26.902,28.287v30.201h36.098v-29.162c22.347-8.293,35.762-31.826,31.762-55.65 c-4.112-24.493-25.764-42.65-50.436-41.736c-5.587-0.692-10.26-4.959-11.371-11.574c-1.275-7.596,3.142-14.36,9.652-16.207 c6.548-1.858,13.017,1.306,15.684,8.463l0.344,0.92l33.826-12.604l-0.342-0.918c-5.162-13.856-16.08-24.239-29.119-29.184v-29.148 L220.844,671.96L220.844,671.96z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F39C12"
    },
    d: "M222.805,673.923h32.176v28.52l0.645,0.234c12.51,4.542,23.023,14.329,28.203,27.398l-30.18,11.244 c-3.202-7.335-10.472-10.807-17.635-8.775c-7.498,2.127-12.481,9.9-11.051,18.418c1.239,7.377,6.623,12.398,13.064,13.195 l0.08,0.01l0.08-0.002c23.733-0.959,44.621,16.515,48.582,40.107c3.886,23.145-9.292,46.041-31.137,53.777l-0.652,0.232V886.8 h-32.176v-29.51l-0.602-0.252c-11.554-4.846-21.156-14.244-26.033-26.551l30.182-11.244c3.201,7.336,10.474,10.807,17.637,8.775 c7.498-2.127,12.481-9.902,11.051-18.42c-1.238-7.372-6.618-12.388-13.053-13.191l-0.08-0.012l-0.082,0.004 c-23.737,0.965-44.63-16.514-48.592-40.109c-3.755-22.367,8.428-44.5,28.965-52.943l0.607-0.25L222.805,673.923L222.805,673.923z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D89E22"
    },
    d: "M149.287,781.153c0,8.028-6.508,14.536-14.536,14.536s-14.536-6.508-14.536-14.536 s6.508-14.536,14.536-14.536S149.287,773.125,149.287,781.153z"
  }), /*#__PURE__*/React.createElement("path", {
    shapeRendering: "auto",
    imageRendering: "auto",
    colorRendering: "auto",
    colorInterpolation: "sRGB",
    style: {
      fill: "#F39C12"
    },
    d: " M133.52,765.033c-8.293,0-15.025,6.732-15.025,15.025s6.732,15.027,15.025,15.027s15.025-6.734,15.025-15.027 S141.813,765.033,133.52,765.033z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D89E22"
    },
    d: "M361.507,781.153c0,8.028-6.508,14.536-14.536,14.536s-14.536-6.508-14.536-14.536 s6.508-14.536,14.536-14.536S361.507,773.125,361.507,781.153z"
  }), /*#__PURE__*/React.createElement("path", {
    shapeRendering: "auto",
    imageRendering: "auto",
    colorRendering: "auto",
    colorInterpolation: "sRGB",
    style: {
      fill: "#F39C12"
    },
    d: " M345.738,765.033c-8.293,0-15.025,6.732-15.025,15.025s6.732,15.027,15.025,15.027s15.027-6.734,15.027-15.027 S354.031,765.033,345.738,765.033z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEBC1A"
    },
    d: "M386.654,921.048c-8.352-6.549-9.813-18.629-3.264-26.981c6.549-8.352,18.629-9.813,26.981-3.264 s9.813,18.629,3.264,26.981S395.005,927.598,386.654,921.048C386.653,921.048,386.653,921.048,386.654,921.048L386.654,921.048z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEBC1A"
    },
    d: "M66.389,669.918c-8.352-6.549-9.814-18.629-3.265-26.981c6.549-8.352,18.629-9.813,26.981-3.264 s9.814,18.629,3.265,26.981C86.82,675.006,74.741,676.467,66.389,669.918z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEBC1A"
    },
    d: "M332.37,961.865c-5.745-8.924-3.168-20.816,5.756-26.561l0,0 c8.924-5.745,20.816-3.168,26.561,5.756l0,0c5.745,8.924,3.168,20.816-5.756,26.561l0,0 C350.007,973.367,338.115,970.789,332.37,961.865L332.37,961.865z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEBC1A"
    },
    d: "M112.071,619.661c-5.745-8.924-3.168-20.816,5.756-26.561s20.816-3.168,26.561,5.756h0 c5.745,8.924,3.168,20.816-5.756,26.561S117.816,628.585,112.071,619.661L112.071,619.661z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEBC1A"
    },
    d: "M325.87,595.635c-3.621,9.977-14.644,15.129-24.621,11.508l0,0 c-9.977-3.621-15.129-14.644-11.508-24.621c3.621-9.977,14.644-15.129,24.621-11.508 C324.339,574.635,329.491,585.658,325.87,595.635L325.87,595.635z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEBC1A"
    },
    d: "M187.017,978.199c-3.621,9.977-14.644,15.129-24.621,11.508 c-9.977-3.621-15.129-14.644-11.508-24.621c3.621-9.977,14.644-15.129,24.621-11.508 C185.486,957.2,190.638,968.223,187.017,978.199z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinIcon);
export default __webpack_public_path__ + "static/media/coin-icon.da2eaca120943bda0133cbc945afedb4.svg";
export { ForwardRef as ReactComponent };